import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountMetricInsightsMetricType } from '../../dtos/challenge-insights/account-metrics-insights-metric-type.enum';
import { GetAccountMetricsInsightsChartDataRequestDto } from '../../dtos/challenge-insights/get-account-metrics-insights-chart-data.request.dto';
import { GetAccountMetricsInsightsChartDataResponseDto } from '../../dtos/challenge-insights/get-account-metrics-insights-chart-data.response.dto';
import { GetAccountMetricsInsightsChartDataPresenter } from '../../presenters/challenge-insights/get-account-metrics-insights-chart-data.presenter';
import { GetAccountMetricsInsightDigitalIntensityChartDataQuery } from '../../queries/challenge-insights/digital-intensity/get-account-metrics-insight-digital-intensity-chart-data.query';
import { GetAccountMetricsInsightDigitalWorkingHoursChartDataQuery } from '../../queries/challenge-insights/digital-working-hours/get-account-metrics-insight-digital-working-hours-chart-data.query';
import { GetAccountMetricsInsightFocusV1ChartDataQuery } from '../../queries/challenge-insights/focus-v1/get-account-metrics-insight-focus-v1-chart-data.query';
import { GetAccountMetricsInsightSelfReportChartDataQuery } from '../../queries/challenge-insights/self-report/get-account-metrics-insight-self-report-chart-data.query';
import { GetAccountMetricsInsightSentimentChartDataQuery } from '../../queries/challenge-insights/sentiment/get-account-metrics-insight-sentiment-chart-data.query';
import { GetAccountMetricsInsightTimeInAppsChartDataQuery } from '../../queries/challenge-insights/time-in-apps/get-account-metrics-insight-time-in-apps-chart-data.query';
import { GetAccountMetricsInsightTimeInCallsChartDataQuery } from '../../queries/challenge-insights/time-in-calls/get-account-metrics-insight-time-in-calls-chart-data.query';
import { GetAccountMetricsInsightTimeInCategoriesChartDataQuery } from '../../queries/challenge-insights/time-in-categories/get-account-metrics-insight-time-in-categories-chart-data.query';
import { GetAccountMetricsInsightTimeInMeetingsChartDataQuery } from '../../queries/challenge-insights/time-in-meetings/get-account-metrics-insight-time-in-meetings-chart-data.query';

export class GetAccountMetricsInsightsChartDataCompositeController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly getAccountMetricsInsightFocusV1ChartDataQuery: GetAccountMetricsInsightFocusV1ChartDataQuery,
    protected readonly getAccountMetricsInsightDigitalWorkingHoursChartDataQuery: GetAccountMetricsInsightDigitalWorkingHoursChartDataQuery,
    protected readonly getAccountMetricsInsightTimeInAppsChartDataQuery: GetAccountMetricsInsightTimeInAppsChartDataQuery,
    protected readonly getAccountMetricsInsightTimeInCategoriesChartDataQuery: GetAccountMetricsInsightTimeInCategoriesChartDataQuery,
    protected readonly getAccountMetricsInsightTimeInMeetingsChartDataQuery: GetAccountMetricsInsightTimeInMeetingsChartDataQuery,
    protected readonly sentimentChartDataQuery: GetAccountMetricsInsightSentimentChartDataQuery,
    protected readonly timeInCallsChartDataQuery: GetAccountMetricsInsightTimeInCallsChartDataQuery,
    protected readonly digitalIntensityQuery: GetAccountMetricsInsightDigitalIntensityChartDataQuery,
    protected readonly selfReportQuery: GetAccountMetricsInsightSelfReportChartDataQuery,
    protected readonly presenter: GetAccountMetricsInsightsChartDataPresenter
  ) {}
  async get(
    props: GetAccountMetricsInsightsChartDataRequestDto
  ): Promise<GetAccountMetricsInsightsChartDataResponseDto> {
    this.logManager.debug(
      'GetAccountMetricsInsightsChartDataCompositeController called with props:',
      props
    );
    const metricType = props.params.metricType;

    if (metricType === AccountMetricInsightsMetricType.FocusV1) {
      const focusV1 =
        await this.getAccountMetricsInsightFocusV1ChartDataQuery.execute(props);
      return this.presenter.toResponse(focusV1);
    }

    if (metricType === AccountMetricInsightsMetricType.DigitalWorkingHours) {
      const entities =
        await this.getAccountMetricsInsightDigitalWorkingHoursChartDataQuery.execute(
          props
        );
      return this.presenter.toResponse(entities);
    }

    if (metricType === AccountMetricInsightsMetricType.TimeInCategory) {
      const entities =
        await this.getAccountMetricsInsightTimeInCategoriesChartDataQuery.execute(
          props
        );
      return this.presenter.toResponse(entities);
    }
    if (metricType === AccountMetricInsightsMetricType.TimeInApp) {
      const entities =
        await this.getAccountMetricsInsightTimeInAppsChartDataQuery.execute(
          props
        );
      return this.presenter.toResponse(entities);
    }
    if (metricType === AccountMetricInsightsMetricType.TimeInMeetings) {
      const entities =
        await this.getAccountMetricsInsightTimeInMeetingsChartDataQuery.execute(
          props
        );
      return this.presenter.toResponse(entities);
    }
    if (metricType === AccountMetricInsightsMetricType.Sentiment) {
      const sentimentData = await this.sentimentChartDataQuery.execute(props);
      return this.presenter.toResponse(sentimentData);
    }

    if (metricType === AccountMetricInsightsMetricType.TimeInCalls) {
      const timeInCalls = await this.timeInCallsChartDataQuery.execute(props);
      return this.presenter.toResponse(timeInCalls);
    }

    if (metricType === AccountMetricInsightsMetricType.DigitalIntensity) {
      const entities = await this.digitalIntensityQuery.execute(props);
      return this.presenter.toResponse(entities);
    }

    if (metricType === AccountMetricInsightsMetricType.SelfReport) {
      const entities = await this.selfReportQuery.execute(props);
      return this.presenter.toResponse(entities);
    }
  }
}
